import {createVNode} from "vue";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";
import { notification,Modal } from 'ant-design-vue';
import {StorageUtils, formatDate, getUrlParams} from 'xmgoing-utils';
import {QueryCommand} from "xmgoing-server";
import {deepClone, GoingNewUtils, md5Str, formatMoney} from 'xmgoing-utils';
import {RoleEnum} from "@/enums/roleEnum";
import emitter from "@/events/eventBus";
import {DateDiffGetDateDiff, getCurDate, loadOutSystem} from "@/utils/xmCom/loadSystem";
import i18n from "@/i18n";
import dayjs from "dayjs";
import { message } from 'ant-design-vue';
import {calculateAndAllocateDiscount, updateMaterialRow, splitMaterialWithQuantity} from "@/main-page/utils/moneyUtils";
import {CurrentUtils} from "xmgoing-server";

(window as any).formatMoney = formatMoney;
interface IConfirm {
  content: string,//提示信息
  title?: string; // 确认框标题，未配置时不显示
  backFun: Function,
  cancelFun?:Function
}

export function getRandomColor () {
  const ary = ['#2490F8', '#6245F8', '#F76B35', '#CB0000', '#B74DBE', '#7BB68A', '#F742AA', '#337AB7', '#59BBCC']
  const index = Math.floor(Math.random() * ary.length)
  return ary[index]
}
/**
 * 初始化树形菜单的相关数据
 * @param list
 */
export const initTreeMenuData=function (list,level){
  list.forEach((itemDb)=>{
    itemDb.level=level;
    itemDb.source=itemDb.menuIcon;
    if((itemDb.path+"").indexOf("xm-erp")<=0){
      itemDb.path=itemDb.path
    }
    delete itemDb.menuIcon;
    if(level>=1){
      delete itemDb.children;
    }
    if(itemDb&&itemDb.children){
      initTreeMenuData(itemDb.children,++itemDb.level);
    }
  })
}

/**
 * 循环所有节点 给每个节点设置相应的子节点集合
 * @param pRecord
 * @param allRecords
 */
const initSonMenus=function (pRecord,allRecords){
  const sonItems=allRecords.filter((record)=>{
    return record.parentId===pRecord.id;
  });
  if(sonItems&&sonItems.length>0){
    pRecord.children=sonItems;
    if(pRecord.children&&pRecord.children.length>0){
      pRecord.type="menu";
    }
    sonItems.forEach((sonItem)=>{
      initSonMenus(sonItem,allRecords);
    })
  }
}


const GoingUtils = {
  isRunning:true,
  isMesSystem:true,
  /**
   * 校验系统到期时间
   */
  loadSystemDateVaildate(){
    const queryCommand = new QueryCommand({
      url: `/api/go-lcc/gateway/expireTime`,
      showTip: false,
      method:"GET",
    });
    queryCommand.executeQueryPromise({params:{}}).then((res)=>{
      const curDate = getCurDate();
      const endDate = dayjs(res).format('YYYY-MM-DD');
      if (DateDiffGetDateDiff(curDate, endDate, "day") <= 0) {
        loadOutSystem({timeOut:true});
      }
    })
  },
  getStartDay(endDay,timeLong){
    const timeLongAry=timeLong.split(":");
    if(timeLong[1]){
      return dayjs(dayjs(endDay, 'YYYY-MM-DD HH:mm').subtract(timeLongAry[0], 'hour').subtract(timeLongAry[1], 'minute')).format('YYYY-MM-DD HH:mm');
    }else{
      return dayjs(dayjs(endDay, 'YYYY-MM-DD HH:mm').subtract(timeLongAry[0], 'hour')).format('YYYY-MM-DD HH:mm');
    }
  },
   /**
   * 根据总折扣金额和列表数据来计算并分配折扣，当前代码内部直接调用自身是错误的，应该调用对应的业务逻辑函数来实现此功能，这里示例假设后续会替换为正确的函数调用
   * @param totalDiscountAmount 总折扣金额，类型为数字，代表可分配的折扣总数额，具体业务含义根据实际场景确定
   * @param list 折扣分配相关的列表数据，类型为对象数组，数组中每个元素包含参与折扣分配计算的相关数据，具体结构根据业务需求确定
   * @param useActQuantity 是否启用实发数量，类型为布尔值，用于确定是否在计算折扣等字段时使用实发数量，具体业务含义根据实际场景确定
   */
  calculateAndAllocateDiscount(totalDiscountAmount: number, list: any[], useActQuantity = false) {
    return calculateAndAllocateDiscount(totalDiscountAmount, list, useActQuantity);
  },
  // 关闭整单折扣
  updateWholeOrderDiscount(formObj, field1 = 'enterWholeOrderDiscount', field2 = 'wholeOrderDiscountAmount', needTips = false) {
    console.log('----------updateWholeOrderDiscount----------', formObj)
    if (needTips && formObj.sourceDocumentCode && formObj.sourceDocumentCode.length > 0) {
      const totalDiscountAmount = parseFloat(formObj.totalDiscountAmount);
      if (!isNaN(totalDiscountAmount) && totalDiscountAmount > 0) {
        GoingUtils.showWarningMsg('当前单据为下推数据，修改单据内容后，折扣额以提交后的折扣为准！');
        return;
      }
    }
    if(formObj[field1] && (formObj[field1] === true || formObj[field1] === 'true')) {
      // 整单折扣模式 修改数量、单价等字段时，需要清空整单折扣额
      GoingUtils.showWarningMsg('金额变动，会清空折扣数据，请仔细确认！');
      formObj[field1] = false;
      formObj[field2] = 0;
    }
  },
  getUserName(){
    let userName='当前用户'
    CurrentUtils._loadUser(false, (user) => {
      userName=user.realName||user.phone||'当前用户';
    })
    return userName;
  },
   /**
   * 更新物料行数据并联动计算相关字段
   * @param {Object} record - 当前行数据对象
   * @param {string} field - 变化的字段名
   * @param {number} cellValue - 变化后的值
   * @param {Object} formObj - 整个表单对象
   */
  discountInputChange(record, field, cellValue, formObj, enterType = '', params = {}) {
    updateMaterialRow(record, field, cellValue, formObj, enterType, params)
  },
  /**
   * 拆分物料后更新金额等数据
  */
  splitMaterialWithQuantity(material, record, useActQuantity = false) {
    splitMaterialWithQuantity(material, record, useActQuantity)
  },
  uniqueRecordsByProp({records,propName}){
    if (records && records.length > 0) {
      // 使用 Set 过滤 name 重复的数据
      const uniqueNames = new Set();
      const filteredRecords = records.filter((record) => {
        if (!uniqueNames.has(record[propName])) {
          uniqueNames.add(record[propName]);
          return true;
        }
        return false;
      });
      return filteredRecords;
    }
  },
  getEventCtlKey(key){
    return this.getPageCode()+"_"+key;
  },
  getPageCode(pageCodeStr=''){
    if(pageCodeStr===""){
      pageCodeStr=window.location.href;
    }
    const pageCodeAry = pageCodeStr.split("/");
    let lastPage=pageCodeAry[pageCodeAry.length - 1];
    lastPage=lastPage.split("?")[0];
    return lastPage;
  },
  isKeepAlive:true,
  onActivatedFlush:false,
  isDesFlag(){
    return  false;
  },
  //两个日期天数间隔
  calculateDayInterval(start, end) {
    // 1. 转换为dayjs对象并忽略时间部分（统一到00:00:00）
    const startDate = dayjs(start).startOf('day');
    const endDate = dayjs(end).startOf('day');
    // 2. 计算自然日差值（包含首尾日期）
    const diffDays = endDate.diff(startDate, 'day') + 1;
    return diffDays;
  },
  loading: null,
  defUnit: 'px',
  isFullScreenFlag: false,
  gridKey: '',
  getMaxRecords: 9999,
  getUUChar(len){
    return GoingNewUtils.getUUChar(len);
  },
  md5Str(str) {
    return md5Str(str);
  },
  deepClone(obj) {
    return deepClone(obj);
  },
  /**
   * 获取url的最后名称
   * @param href
   */
  getUrlLastName() {
    const {
      href,
    } = location;
    const hrefAry = href.split("/");
    let lastName = hrefAry[hrefAry.length - 1];
    if (lastName.indexOf("?") >= 0) {
      lastName = lastName.split("?")[0];
    }
    return lastName;
  },
  getIsPreview() {
    if (window.subAppObj.preview || (window.appObj && window.appObj.preview)) {
      return true;
    } else {
      return false;
    }
  },
  loadTimer:null,
  loadTimerAgain:null,
  formatDate(date,format){
    return  formatDate(date,{format})
  },
  getRandomColor(){
    return getRandomColor();
  },
  getUseI18n(){
    return i18n.global.t;
  },
  layoutSystem(){
    // 如果以前存在 则清空
    if (GoingUtils.loadTimer != null) {
      clearTimeout(GoingUtils.loadTimer)
    }

    // 跳转到登陆界面
    (GoingUtils as any).loadTimer = setTimeout(function () {
      if(emitter){
        window.appObj.sessionTimeout=true;
        emitter.emit('useLockStore');
        GoingUtils.loadTimerAgain=setTimeout(function (){
          loadOutSystem();
        },500);
      }else{
        loadOutSystem();
      }
    }, 1500);
  },
  pageHeightDef:0,
  //计算界面def高度
  addTabHeight(tabHeight){
    GoingUtils.pageHeightDef=GoingUtils.pageHeightDef+tabHeight||0;
  },
  //获取界面def高度
  getPageHeightDef(){
    return GoingUtils.pageHeightDef;
  },
  getTableHeight({queryAreaHeight=145,topHeight=0,bigFlag=false}){
    const queryArea=queryAreaHeight||145,
      queryAreaPadding=40,
      toolBar=60,
      pagePadding=40,
      pagePagin=40;
    let diffH=queryArea+queryAreaPadding+toolBar+pagePadding+pagePagin;
    if(document.querySelector(".vben-multiple-tabs")){
      diffH=diffH+(document.querySelector(".vben-multiple-tabs") as any).offsetHeight;
    }
    if(document.querySelector("#PageLayout")){
      //子应用模式下
      return parseFloat((document.querySelector("#PageLayout") as any).offsetHeight-diffH+(bigFlag?140:0)) - parseFloat(topHeight);
    }else{
      //主框架模式下
      let selDomEl=document.querySelector(".getLayoutContentMode");
      if(selDomEl){
        return (selDomEl as any).offsetHeight-diffH+(bigFlag?140:0) - topHeight;
      }
      //app应用模式下
      selDomEl=document.querySelector(".vben-frameBody-frame-body-div");
      if(selDomEl){
        return (selDomEl as any).offsetHeight-diffH+(bigFlag?140:0) - topHeight;
      }
      return document.body.clientWidth;
    }

  },
  initAdminUserRotes(userRotes:any){
    const routes:any=[{children:[]}];
    userRotes.forEach((moduleRecord)=>{
      //如果没有顶层节点 则包一层
      console.log((moduleRecord.parentId+""),"========(moduleRecord.parentId+\"\")")
      if((moduleRecord.parentId+"")==='-1'||(moduleRecord.parentId+"")==='0'){
        if(moduleRecord.type==null||moduleRecord.type===""){
          moduleRecord.type="menu";
        }
        initSonMenus(moduleRecord,userRotes);
        routes[0].children.push(moduleRecord);
      }
    })
    return routes;
  },
  //是否为单位管理员
  isUnitAdmin(position):boolean{
    if(position==null||position===""){
      position=StorageUtils.getSessionItem("loginUserType");
    }
    if(position===RoleEnum.USER_UNIT_ROLE){
      return  true;
    }
    return false;
  },
  isNotSystemOrGroup():boolean{
    const position=StorageUtils.getSessionItem("loginUserType");
    //如果是系统管理员
    if(position===RoleEnum.USER_SYSTEM_ROLE){
      return false;
    }
    if(position===RoleEnum.USER_GROUP_ADMIN_ROLE){
      return false;
    }
    return  true;
  },
  //是否为运营管理
  isSystem(position):boolean{
    if(position==null||position===""){
      position=StorageUtils.getSessionItem("loginUserType");
    }
    if(position===RoleEnum.USER_SYSTEM_ROLE){
      return  true;
    }
    return false;
  },
  //是否为运营管理
  isGroupAdmin(position):boolean{
    if(position==null||position===""){
      position=StorageUtils.getSessionItem("loginUserType");
    }
    if(position===RoleEnum.USER_GROUP_ADMIN_ROLE){
      return  true;
    }
    return false;
  },
  operateLoginFlag():boolean{
    const loginUserType = getUrlParams('loginUserType', true) || StorageUtils.getSessionItem('loginUserType');
    if(loginUserType==='operateUser'){
      return  true;
    }else{
      return  false;
    }
  },
  //app显示标志
  isAppShowFlag():boolean{
    const pageType = StorageUtils.getSessionItem("pageType");
    if(pageType==='appShow'){
      return true;
    }
    const showApp = StorageUtils.getSessionItem("showApp");
    if((showApp+"")!=="true"){
      return false;
    }else{
      return true;
    }
  },
  /**
   * 点击确认 后操作
   * @param content
   * @param backFun
   */
  executeConfirm({content, title, backFun, cancelFun}: IConfirm) {
    const confirmOptions: Record<string, any> = {
      content,
      icon: createVNode(ExclamationCircleOutlined),
      onOk() {
        return new Promise(() => {
          backFun && backFun();
          Modal.destroyAll();
        }).catch(() => console.log('Oops errors!'));
      },
      okText: '确定',
      cancelText: '取消',
      onCancel() {
        cancelFun && cancelFun();
        Modal.destroyAll();
      },
    };
    if (title != null && title !== '') {
      confirmOptions.title = title;
    }
    Modal.confirm(confirmOptions);
  },
  showMoreErrorResults(results,cancelFun){
    const List:any=[];
    if(results&&Array.isArray(results)){
      results.forEach((itemDb)=>{
        List.push(h('div', {}, itemDb.errorMsg))
      })
    }else{
      if(results.errorMsg&&Array.isArray(results.errorMsg)){
        results.errorMsg.forEach((contentItem)=>{
          List.push(h('div', {}, contentItem))
        })
      }
    }
    Modal.confirm({
      title: results.title,
      icon: createVNode(ExclamationCircleOutlined),
      okText: '我知道了',
      content: h(
        'div',
        {
          style: {
            'max-height': '200px',
            'overflow-y': 'auto',
          },
        },
        List
      ),
      onCancel() {
        cancelFun&&cancelFun();
        Modal.destroyAll();
      },
    });
  },
  showWarningMsg(msg){
    message.warning(msg);
  },
  showErrorMsg(msg){
    message.error(msg);
  },
  errorMesg:{},
  // 弹框提示错误信息
  showErrorMessage(msg:string | {title?: any, content?: string, msg?: string, message?: string},status=205){
    let text = '';
    if (typeof msg === 'string') {
      text = msg;
    } else if (msg != null) {
      text = msg.content || msg.title || msg.msg || msg.message || '';
    }
    if (!(text + '').trim()) {
      return;
    }
    if (GoingUtils.errorMesg[text]) {
      clearTimeout(GoingUtils.errorMesg[text]);
    }
    GoingUtils.errorMesg[text] = setTimeout(() => {
      if((status+'')==='400'||(status+'')==='500'){
        message.error(text);
      }else{
        message.warning(text);
      }
    }, 300)
  },
  //显示消息
  showMessage(msg:string){
    let message="信息提示";
    let projectI18n=StorageUtils.getSessionItem("projectI18n")||StorageUtils.getItem("projectI18n");
    if(projectI18n==='en'){
      message="Info Message"
    }
    notification.success({
      message,
      description:msg,
      type: 'info',
    });
  },
  // 关闭loading
  closeLoading (): void {
    window&&window.hideLoadingFun&&window.hideLoadingFun();
  },
  loadingObjs: [],
  // 显示加载loading
  showLoading (): void {
    if(window.GoingUtils.ctlLoading){
      return;
    }
    window&&window.showLoadingFun&&window.showLoadingFun();
    setTimeout(()=>{
      this.closeLoading();
    },3000)
  }
}
window.GoingUtils=GoingUtils;
export default GoingUtils;
